export default __webpack_public_path__ + "fd6ef4878ca52be10fb740a8d25275e7.svg";